import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import ConfirmClick from '../../../common/ConfirmClick';
import Spinner from '../../../common/Spinner';
import Tooltip from '../../../common/Tooltip';
import AbsoluteValue from '../../../common/AbsoluteValue';
import CopyToClipboard from '../../../common/CopyToClipboard';
import { avgFooter, convertSumFooter, textFooter, spaceFooter } from '../../../common/Datagrid/Footers';
import { convertToThousands, splitByThousands } from  '../../../../helpers/NumberFormatter';

export const youtubeSourcesSettings = {
    settingsForTable
};

function getLogoCell(item, entity) {
    return 
}

function settingsForTable(channelTypes, refresh){
    let columns = [
       {
           id: 'source',
           className: "imprint-name",
           headerClassName: "imprint-name no-sort",
           sortable: false,
           Header: 'Source',
           accessor: 'source',
           Footer: textFooter,
           minWidth: 250
    
       },
       {
           id: 'total',
           className: '',
           Header: props => <div className="top-table-header-inner">
               Total
               <div className="table-header-tooltip">
                    <Tooltip position="bottom" message={`tbd.`} tooltipClass="toolbar-title-tooltip"/>
                </div>
            </div>,
           accessor: 'total',
           width: 160,
           Footer: convertSumFooter,
           Cell: props => <AbsoluteValue value={props.value} />
       },
       {
           id: 'engaged',
           className: '',
           Header: props => <div className="top-table-header-inner">
               Engaged
               <div className="table-header-tooltip">
                    <Tooltip position="bottom" message={`tbd.`} tooltipClass="toolbar-title-tooltip"/>
                </div>
                </div>,
    
           accessor: 'engaged',
           width: 160,
           Footer: convertSumFooter,
           Cell: props => <AbsoluteValue value={props.value} />
       },       
       {
           id: 'free',
           className: '',
           Header: 'Free',
           accessor: 'free',
           width: 160,
           Footer: convertSumFooter,
           Cell: props => <AbsoluteValue value={props.value} />
       },
       {
           id: 'premium',
           className: '',
           Header: 'Premium',
           accessor: 'premium',
           width: 160,
           Footer: convertSumFooter,
           Cell: props => <AbsoluteValue value={props.value} />           
       }];    
    return columns;
}